import * as React from 'react';
import classNames from 'classnames';
import IMPComponent from '../../interfaces/IMPComponent';
import { HTMLProps } from 'react';

import './styles.scss';

export interface IFormInput extends IMPComponent, HTMLProps<HTMLInputElement> {
  block?: boolean;
  error: boolean;
}

const FormInput: React.FunctionComponent<IFormInput> = ({ className, style, block, error, ...props }) => {
  const cn = classNames('FormInput', className, {
    'FormInput--block': block,
    'FormInput--error': error,
  });
  return <input className={cn} {...props} />;
};

FormInput.defaultProps = {
  block: false,
  error: false,
};

export default React.memo(FormInput);



// WEBPACK FOOTER //
// ./src/components/Form/FormInput/index.tsx